import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SessionService} from '../session.service';
import {concatMap, filter} from 'rxjs/operators';
import {CacheService} from '../cache.service';

@Component({
  selector: 'ims-sso-redirect',
  templateUrl: './sso-redirect.component.html',
  styleUrls: ['./sso-redirect.component.less']
})
export class SsoRedirectComponent implements OnInit {

  private parent;
  private func;
  private token;

  constructor(activatedRoute: ActivatedRoute,
              private cache: CacheService,
              private sess: SessionService,
              private router: Router) {
    this.parent = activatedRoute.snapshot.paramMap.get('parent');
    this.func = activatedRoute.snapshot.paramMap.get('func');
    this.token = activatedRoute.snapshot.paramMap.get('token');
  }

  ngOnInit() {
    this.sess.authWithToken(this.token)
      .pipe(
        concatMap(() => this.cache.init$.pipe(filter(i => i))),
      ).subscribe(() => {
      this.router.navigate([this.parent, this.func]).then();
    });
  }

}
